import { render } from "./RallyGate.vue?vue&type=template&id=04520ebb"
import script from "./RallyGate.vue?vue&type=script&lang=js"
export * from "./RallyGate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__